import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CookieKeys from '../../constants/CookieKeys';
import FeatureTogglesContext from '../../contexts/FeatureTogglesContext';
import useRouting from '../../hooks/useRouting';
import { useTranslation } from 'react-i18next';
import Cookies from '../../utils/Cookies';
import NotificationBanner from '../NotificationBanner';

function CookieNotificationBanner() {
  const support = navigator.cookieEnabled;

  const [accepted, setAccepted] = useState(Cookies.get(CookieKeys.cl) === 'true');
  const { r } = useRouting();

  const { REACT_APP_ANALYTICS_KEY } = process.env;

  useEffect(() => {
    if (!accepted) window[`ga-disable-${REACT_APP_ANALYTICS_KEY}`] = true;
  }, [REACT_APP_ANALYTICS_KEY, accepted]);

  const acceptCookies = () => {
    const now = new Date();

    const expires = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());

    setAccepted(true);

    window[`ga-disable-${REACT_APP_ANALYTICS_KEY}`] = false;

    Cookies.set(CookieKeys.cl, 'true', { expires });
  };

  const { t } = useTranslation();

  const featureToggles = useContext(FeatureTogglesContext);

  if (!support) {
    return (
      <NotificationBanner variant="danger">
        {t('COMPONENTS.NOTIFICATION_BAR.COOKIES.NO_COOKIES_SUPPORTED')}
      </NotificationBanner>
    );
  }

  if (!accepted) {
    return (
      <NotificationBanner
        variant="info"
        dismissible
        onDismiss={acceptCookies}
        dismissibleStartAdornment={t('COMPONENTS.NOTIFICATION_BAR.COOKIES.ACTIONS.AGREE')}
      >
        {t('COMPONENTS.NOTIFICATION_BAR.COOKIES.ACCEPT_POLICY')}{' '}
        <Link to={featureToggles.PRIVACY_POLICY ? r('privacy-policy') : r('terms-and-conditions')}>
          {t('COMPONENTS.NOTIFICATION_BAR.COOKIES.POLICY_LINK')}
        </Link>
      </NotificationBanner>
    );
  }

  return null;
}

export default CookieNotificationBanner;
